<template>
  <div class="approval-manager">
    <div class="manager-level paragraph form-item">
      <span class="input-label">主管级别：</span>
      <el-select
        v-model="formData.supervisorLevel"
        placeholder="请选择"
        size="medium"
        @change="resetMaxSupervisorLevel"
      >
        <el-option
          v-for="item in managerLevels"
          :key="item.name"
          :label="item.name"
          :value="item.code"
        ></el-option>
      </el-select>
    </div>

    <el-divider></el-divider>
    <el-checkbox
      v-model="showMaxSupervisorLevel"
      class="paragraph"
      :disabled="transferSupervisorDisabled"
      @change="initMaxSupervisorLevel"
    >找不到主管时，由上级主管转交</el-checkbox>
    <div class="max-manager-level form-item" v-show="showMaxSupervisorLevel">
      <span class="input-label">最多向上查找：</span>
      <el-select v-model="formData.maxSupervisorLevel" placeholder="请选择" size="medium">
        <el-option
          v-for="item in maxManagerLevels"
          :key="item.name"
          :label="item.name"
          :value="item.code"
        ></el-option>
      </el-select>
    </div>

    <el-divider></el-divider>

    <el-checkbox
      v-model="showMutiDepartmentSignSetting"
      class="paragraph"
      @change="initMutiDepartmentSignSetting"
    >涉及多部门时，须由所有部门的主管共同审批</el-checkbox>
    <el-radio-group
      v-model="formData.multiDepartmentSignType"
      class="multiDepartmentSignType"
      v-show="showMutiDepartmentSignSetting"
    >
      <el-radio label="andSign">部门会签</el-radio>
      <el-radio label="orSign">部门或签</el-radio>
    </el-radio-group>

    <el-checkbox
      v-model="notFoundOtherDepartmentSupervisor"
      v-show="showMutiDepartmentSignSetting"
    >涉及部门主管为空时，视为自动拒绝</el-checkbox>
  </div>
</template>

<script>
import { getManagerLevels, getMaxManagerLevels } from "./config";

export default {
  props: {
    approvalData: {
      type: Object,
      required: true
    }
  },

  computed: {
    maxManagerLevels() {
      return getMaxManagerLevels(this.formData.supervisorLevel);
    },

    transferSupervisorDisabled() {
      const levels = ["0", "20"];
      const toggle =
        levels.find(x => x === this.formData.supervisorLevel) ||
        !this.formData.supervisorLevel;

      if (toggle) this.showMaxSupervisorLevel = false;

      return toggle ? true : false;
    },

    relateFormData() {
      let {
        supervisorLevel,
        maxSupervisorLevel,
        multiDepartmentSignType,
        notFoundOtherDepartmentSupervisor
      } = this.approvalData;
      return {
        supervisorLevel,
        maxSupervisorLevel,
        multiDepartmentSignType,
        notFoundOtherDepartmentSupervisor
      };
    },

    requestFormData() {
      const notFoundOtherDepartmentSupervisor = this
        .notFoundOtherDepartmentSupervisor
        ? "autoReject"
        : "";

      let requestFormData = {
        ...this.formData,
        notFoundOtherDepartmentSupervisor
      };
      return requestFormData;
    }
  },

  watch: {
    relateFormData: {
      deep: true,
      handler(newValue, oldValue) {
        this.setFormData(newValue);
      }
    }
  },

  data() {
    return {
      managerLevels: getManagerLevels(),

      value: "",

      formData: {
        supervisorLevel: "",
        maxSupervisorLevel: "",
        multiDepartmentSignType: "orSign"
      },
      notFoundOtherDepartmentSupervisor: false,

      showMaxSupervisorLevel: false,
      showMutiDepartmentSignSetting: false
    };
  },
  methods: {
    resetMaxSupervisorLevel(level) {
      this.formData.maxSupervisorLevel = "";
    },

    initMaxSupervisorLevel() {
      this.formData.maxSupervisorLevel = "";
    },

    initMutiDepartmentSignSetting(bool) {

      this.formData.multiDepartmentSignType = bool ? "orSign" : "";
      this.notFoundOtherDepartmentSupervisor = false;
    },

    setFormData(props) {
      this.formData = this.$js.deepClone(props);

      this.showMaxSupervisorLevel = Boolean(props.maxSupervisorLevel);

      this.showMutiDepartmentSignSetting = Boolean(props.multiDepartmentSignType);

      this.notFoundOtherDepartmentSupervisor = Boolean(
        props.notFoundOtherDepartmentSupervisor
      );
    }
  }
};
</script>

<style scoped lang="scss">
.approval-manager {
  font-size: 14px;

  .paragraph {
    margin: 10px 0 10px 0;
  }

  .el-divider {
    margin: 20px 0;
    background: #fff;
    border-bottom: 1px dashed #dcdfe6;
  }

  .form-item {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .input-label {
      display: inline-block;
      width: 120px;
    }

    .el-select {
      flex: 1;
    }
  }

  .multiDepartmentSignType {
    margin: 10px 0 18px 0;
  }
}
</style>